import _ from 'lodash'

const redirectSignIn = _.get(
    process.env,
    'REACT_APP_REDIRECT_SIGN_IN',
    `${window.location.protocol}//${window.location.host}/me`
)

const redirectSignOut = _.get(
    process.env,
    'REACT_APP_REDIRECT_SIGN_OUT',
    `${window.location.protocol}//${window.location.host}`
)

const awsExports = {
    aws_project_region: _.get(process.env, 'REACT_APP_AWS_PROJECT_REGION'),
    Auth: {
        identityPoolId: _.get(process.env, 'REACT_APP_AUTH_IDENTITY_POOL_ID'),
        region: _.get(process.env, 'REACT_APP_AUTH_REGION'),
        userPoolId: _.get(process.env, 'REACT_APP_AUTH_USER_POOL_ID'),
        userPoolWebClientId: _.get(
            process.env,
            'REACT_APP_AUTH_USER_POOL_WEB_CLIENT_ID'
        ),
        // OPTIONAL - Hosted UI configuration
        oauth: {
            domain: _.get(process.env, 'REACT_APP_AUTH_OAUTH_DOMAIN'),
            scope: [
                'phone',
                'email',
                'profile',
                'openid',
                'aws.cognito.signin.user.admin',
            ],
            redirectSignIn,
            redirectSignOut,
            responseType: 'code', // or 'token', note that REFRESH token will only be generated when the responseType is code
        },
    },
    aws_appsync_graphqlEndpoint: _.get(
        process.env,
        'REACT_APP_APPSYNC_GRAPHQL_ENDPOINT'
    ),
}

export default awsExports
